import { enableProdMode, InjectionToken } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { applyPolyfills, defineCustomElements } from 'index-design-system/dist/loader';
import { AppConfig } from './app/models/app-config';
import { firstValueFrom } from 'rxjs';

export function getHostName(): string {
  return document.location.hostname;
}

export function getSlugFromUrl(): string {
  return document.location.pathname.split("/")[1];
}

export function getInvoiceTrackingKey(): string {
  const href = window.location.href;
  const removeParameter = href.substring(0, href.lastIndexOf('?'));
  const substring = href.indexOf('?') > -1 ?
        removeParameter.substring(href.lastIndexOf('/') + 1) :
        href.substring(href.lastIndexOf('/') + 1);

  return substring;
}

applyPolyfills().then(() => {
  defineCustomElements();
});

if (environment.production) {
  enableProdMode();
}

export function fetchConfig(): Promise<AppConfig> {
  let hostName = getHostName();
  let urlSlug = getSlugFromUrl();

  return fetch('api/brands/' + hostName + '/' + (urlSlug || ''))
    .then(async (response) => {
      let config = { baseHref: '', favIcon: '' } as AppConfig;

      const brands: any[] = await response.json();
      if (brands.length > 0) {
        let brand: any;

        brand = brands[0];

        if (!brand) {
          brand = brands.find(b => !b.urlSlug);
        }

        // assign all the values returned to the config object
        if (brand) {
          Object.freeze(Object.assign(config, { baseHref: brand.urlSlug ?? '', favIcon: brand.faviconUrl }));
        }
      }
      return config;
    });

}

fetchConfig().then((config: AppConfig) => {
  platformBrowserDynamic([
    { provide: 'HOST_NAME', useFactory: getHostName, deps: [] },
    { provide: 'INVOICE_TRACKING_KEY', useFactory: getInvoiceTrackingKey, deps: [] },
    { provide: 'APP_CONFIG', useValue: config }
  ])
    .bootstrapModule(AppModule)
    .catch(err => console.error('An unexpected error occured: ', err));
});


  // TODO: Add hard coded ids / typeids to common location (ENUMS?)
  // TODO: Add unit tests for service methods and components
  // TODO: Review project build warnings.
  // TODO: Add .browserslistrc file to remove IE11 warning.
